// Use Markdown format
export const contentTermsOfUse = `
Welcome to AutoveX’s RoboHub (“we”, “us”, “our”). These Terms of Use (“Terms”) govern your access to and use of the RoboHub platform, applications, APIs, and related services (“Services”). By using our Services, you agree to these Terms. If you do not agree, please do not use our Services.

----------

###### **1. Eligibility**

You must be at least 18 years old and have the legal authority to enter into these Terms. If you are using the Services on behalf of an organisation, you represent that you are authorised to bind the organisation to these Terms.

----------

###### **2. Account Registration**

-   You must create an account to access certain features of our Services.
-   You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.
-   You must promptly notify us of any unauthorised use or security breach.

----------

###### **3. Acceptable Use**

You agree not to:

-   Use the Services for unlawful, fraudulent, or malicious purposes.
-   Interfere with the operation or security of the Services.
-   Attempt to access accounts, data, or systems without permission.
-   Reverse-engineer, modify, or copy any part of the Services except as expressly permitted.

----------

###### **4. Service Availability**

We strive to provide uninterrupted access but do not guarantee continuous or error-free operation. We may suspend, modify, or discontinue the Services at any time for maintenance, upgrades, or other reasons.

----------

###### **5. Intellectual Property**

-   All content, software, and materials in the Services are owned by or licensed to us.
-   You may use them only as permitted under these Terms and solely for your authorised purposes.
-   No rights are granted except those expressly stated.

----------

###### **6. Data and Privacy**

Our collection, use, and disclosure of personal data are governed by our Privacy Policy. You agree that we may process your data in accordance with that policy.

----------

###### **7. Third-Party Integrations**

The Services may connect to third-party systems (e.g., lift control systems, building access systems). We are not responsible for the availability, performance, or security of those third-party services.

----------

###### **8. Disclaimers**

The Services are provided “as is” and “as available.” We disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.

----------

###### **9. Limitation of Liability**

To the fullest extent permitted by law, we are not liable for:

-   Indirect, incidental, special, or consequential damages.
-   Loss of profits, revenue, data, or business opportunities.

----------

###### **10. Termination**

We may suspend or terminate your access if you breach these Terms or if required by law. Upon termination, your right to use the Services will immediately cease.

----------

###### **11. Governing Law and Dispute Resolution**

These Terms are governed by the laws of Singapore. Disputes will first be attempted to be resolved amicably. If unresolved, they shall be submitted to the exclusive jurisdiction of the Singapore courts.

----------

###### **12. Changes to These Terms**

We may update these Terms from time to time. The latest version will be posted on our website with the effective date. Continued use of the Services after changes constitutes acceptance of the revised Terms.

----------

###### **Contact Us**  
For questions about these Terms, please contact:\n
AutoveX Pte Ltd\n
Email: [contact@autovex.ai](mailto:contact@autovex.ai)\n
Address: 73, Ayer Rajah Crescent, #01-07, Singapore 139952
`;